import { Injectable } from '@angular/core';
import { ConstantService } from "../../../core/services/constant.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import {CryptoJsService} from "../../../core/services/crypto-js.service";

@Injectable({
  providedIn: 'root'
})
export class ChannelProjectService {

  private channelProjectUrl= ConstantService.CHANNEL_PROJECT_URL
  private projectId= this.localStorage.getItem('projectId');

  constructor(private http: HttpClient, private readonly localStorage: CryptoJsService) { }

    getListChannelProject(): Observable<any> {
      const projectId = this.localStorage.getItem('projectId');
    return this.http.get<{}>(`${this.channelProjectUrl}?is_enable=true&is_active=true&project_id=${projectId}`).pipe(
        map((data) => {
          return data;
        })
    );
    }

    getListChannelProjectName(): Observable<any> {
        return this.http.get<{}>(`${this.channelProjectUrl}?is_enable=true&is_active=true&project=${this.projectId}`).pipe(
            map((data) => {
                return data;
            })
        );
    }

  postChannelProject(data: {}): Observable<any> {
    return this.http.post<any>(this.channelProjectUrl, data).pipe(
        map((response) => {
          return response;
        })
    );
  }

  patchChannelProject( id:string,data:{}): Observable<any> {
    const url = `${this.channelProjectUrl}${id}`;
    return this.http.patch<{}>(url,data).pipe(
        map((data) => {
          return data;
        })
    );
  }

  deleteChannelProject(id:String): Observable<any> {
    const url = `${this.channelProjectUrl}${id}`;
    return this.http.delete<{}>(url).pipe(
        map((data) => {
          return data;
        })
    );
  }

}
